import React, { Component } from 'react';

import './Home.css';

class Home extends Component {
  render() {
    return (
      <div className="row">
				<div className="offset-2 col-8">
					<div className="card">
						<div className="card-header">
						</div>
						<div className="card-body">
							<div className="row">
								<div className="col">
									<div className="text-center" style={{fontSize : '1.25rem'}}>Welcome to <strong>STARLabs Support Portal</strong></div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/home/Home.jsx